import moment from "moment-timezone";
import { API_VERSION, API_VERSION_V2, API_VERSION_V3, API_VERSION_V4 } from "../config";

export const getApiPath = (apiCallParams) => {
  if (apiCallParams.action.includes("v2/")) return apiCallParams.action.split("v2/")[1];
  if (apiCallParams.action.includes("v3/")) return apiCallParams.action.split("v3/")[1];
  if (apiCallParams.action.includes("v4/")) return apiCallParams.action.split("v4/")[1];
  return apiCallParams.action;
};

export const getApiVersion = (apiCallParams) => {
  if (apiCallParams.action.includes("v2/")) return API_VERSION_V2;
  if (apiCallParams.action.includes("v3/")) return API_VERSION_V3;
  if (apiCallParams.action.includes("v4/")) return API_VERSION_V4;
  return API_VERSION;
};

export const downloadFile = (response, blob) => {
  let fileName = "";
  response.headers.forEach((val, header) => {
    if (header == "content-disposition") {
      if (val && val.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(val);

        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "");
        }
      }
    }
    if (header === "content-type" && val === "application/octet-stream") {
      fileName = "WisdomInstaller";
    }

    if (response?.url?.includes("assess_hosts_for_cloud")) {
      fileName = `Migration-Recommendation-${moment(new Date()).format("YYYYMMDD")}`;
    }

    if (response?.url?.includes("assessment")) {
      fileName = `Assessment-Overview-${moment(new Date()).format("YYYYMMDD")}`;
    }

    if (response?.url?.includes("clients_logins")) {
      fileName = `Accounts-Export-Logins-${moment(new Date()).format("YYYYMMDD")}`;
    }
  });

  if (fileName) {
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.download = fileName === "WisdomInstaller" ? `${fileName}.msi` : fileName;
    link.href = url;
    link.click();
    window.URL.revokeObjectURL(url);
  } else {
    const file = window.URL.createObjectURL(blob);
    window.open(file);
  }
};
